import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import LineUpCard from "./line-up-card";

const artists = [
  {
    name: "Ty Segall",
    sort: "Ty Segall",
    link: "https://ty-segall.com/pages/home",
    img: "ty.jpg",
  },
  {
    name: "Stereolab",
    sort: "Stereolab",
    link: "https://stereolab.co.uk/",
    img: "Stereolab.jpg",
  },
  {
    name: "Model/Actriz",
    sort: "Model/Actriz",
    link: "https://www.modelactriz.com/",
    img: "Model_Actriz.jpg",
  },
  {
    name: "Gwenno",
    sort: "Gwenno",
    link: "https://www.gwenno.info/",
    img: "Gwenno Balcony 1.jpg",
  },
  {
    name: "GHOSTWOMAN",
    sort: "GHOSTWOMAN",
    link: "https://ghost-woman.com/",
    img: "GHOSTWOMAN.jpg",
  },
  {
    name: "Adult DVD",
    sort: "Adult DVD",
    link: "https://adultdvd.band/",
    img: "Adult DVD.jpg",
  },
  {
    name: "Lael Neale",
    sort: "Lael Neale",
    link: "https://laelneale.bandcamp.com/music",
    img: "Lael Neale.jpg",
  },
  {
    name: "Makeshift Art Bar",
    sort: "Makeshift Art Bar",
    link: "https://makeshiftartbar.bandcamp.com/album/lackluster-writing-makes-fundamental-reading",
    img: "Makeshift Art Bar.jpg",
  },
  {
    name: "Floral Image",
    sort: "Floral Image",
    link: "https://floralimageband.com/",
    img: "Floral Image.jpg",
  },
  {
    name: "Bleech 9:3",
    sort: "Bleech 9:3",
    link: "https://bleech93.os.fan/",
    img: "Bleech 9-3.jpg",
  },
  {
    name: "Roller Disco Death Party",
    sort: "Roller Disco Death Party",
    link: "https://rollerdiscodeathparty.bandcamp.com/",
    img: "Roller Death Disco Party.jpg",
  },
  {
    name: "National Playboys",
    sort: "National Playboys",
    link: "https://hotvox.co.uk/artist/national-playboys/",
    img: "National Playboys.jpg",
  },
  {
    name: "Sunstinger",
    sort: "Sunstinger",
    link: "https://sunstinger.bandcamp.com/",
    img: "Sunstinger.jpeg",
  },

  {
    name: "Angine de Poitrine",
    sort: "Angine de Poitrine",
    link: "https://open.spotify.com/artist/13NmOYYfvONNZ9mn2qn8P2?si=1RCaGOBOQhyX3K_OsupIig",
    img: "Angine De Poitrine.jpg",
  },
  {
    name: "Automatic",
    sort: "Automatic",
    link: "https://automatic.band/",
    img: "automatic.jpeg",
  },
  {
    name: "The Belair Lip Bombs",
    sort: "Belair Lip Bombs",
    link: "https://thebelairlipbombs.com/",
    img: "The Belair Lip Bombs.jpg",
  },
  {
    name: "GANS",
    sort: "GANS",
    link: "https://gansnet.os.fan/",
    img: "GANS.png",
  },
  {
    name: "Renny Conti",
    sort: "Renny Conti",
    link: "https://www.rennyconti.com/",
    img: "Renny Conti.jpeg",
  },
  {
    name: "Tanzana",
    sort: "Tanzana",
    link: "https://tanzana.os.fan/",
    img: "Tanzana.jpg",
  },
  {
    name: "Water Machine",
    sort: "Water Machine",
    link: "https://watermachine.bandcamp.com/",
    img: "Water Machine.jpg",
  },
  {
    name: "Curiosity Shop",
    sort: "Curiosity Shop",
    link: "https://curiosityshopmusic.bandcamp.com/",
    img: "Curiosity Shop.jpg",
  },
  {
    name: "Jill Lorean",
    sort: "Jill Lorean",
    link: "https://jilllorean.bandcamp.com/",
    img: "JILL LOREAN.jpg",
  },

  {
    name: "SHAME",
    sort: "SHAME",
    link: "https://www.shame.world/",
    img: "WEBSITE - SHAME.png",
  },
  {
    name: "Billy Nomates",
    sort: "Billy Nomates",
    link: "https://billynomates.bandcamp.com/album/metalhorse",
    img: "WEBSITE - BILLY NOMATES.png",
  },
  {
    name: "Mandy, Indiana",
    sort: "Mandy, Indiana",
    link: "https://firetalkrecs.com/mandyindiana",
    img: "WEBSITE - MANDY, INDIANA.png",
  },
  {
    name: "The KVB",
    sort: "KVB",
    link: "https://thekvb.bandcamp.com/",
    img: "WEBSITE - THE KVB.png",
  },
  {
    name: "Holy Wave",
    sort: "Holy Wave",
    link: "https://holywave.bandcamp.com/music",
    img: "WEBSITE - HOLY WAVE.png",
  },
  {
    name: "Alex Amen",
    sort: "Alex Amen",
    link: "https://alexamen.com/",
    img: "WEBSITE - ALEX AMEN.png",
  },
  {
    name: "The Heavenly Bodes",
    sort: "Heavenly Bodes",
    link: "https://theheavenlybodes.bandcamp.com/",
    img: "WEBSITE - HEAVENLY BODES.png",
  },
  {
    name: "Isabella Strange",
    sort: "Isabella Strange",
    link: "https://isabellastrange.bandcamp.com/album/slick-git",
    img: "WEBSITE - ISABELLA STRANGE.png",
  },
  {
    name: "Acolyte",
    sort: "Acolyte",
    link: "https://acolyte2.bandcamp.com/",
    img: "WEBSITE - ACOLYTE.png",
  },
  {
    name: "Just Like Honey",
    sort: "Just Like Honey",
    link: "https://www.instagram.com/justlikehoneyband/",
    img: "WEBSITE - JUST LIKE HONEY.png",
  },
  {
    name: "Lucky Briar",
    sort: "Lucky Briar",
    link: "https://luckybriar.bandcamp.com/",
    img: "WEBSITE - LUCKY BRIAR.png",
  },

  {
    name: "The Dharma Chain",
    sort: "Dharma Chain",
    link: "https://www.thedharmachain.com/",
    img: "dharmachain.png",
  },
  {
    name: "Puppy Teeth",
    sort: "Puppy Teeth",
    link: "https://puppyteeth1.bandcamp.com/",
    img: "puppyteeth.jpg",
  },
];

const sortedArtists = artists.sort((a, b) => a.sort.localeCompare(b.sort));

function LineUp() {
  return (
    <Container className="LineUp" maxWidth="xl">
      <Box
        sx={{ flexGrow: 1, flexWrap: "wrap", display: { xs: "flex" } }}
        className="lineup-border"
      >
        {sortedArtists.map((artist) => (
          <LineUpCard key={artist.name} artist={artist} />
        ))}
      </Box>
    </Container>
  );
}
export default LineUp;
